module.exports = __webpack_public_path__ + "static/img/jim.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/jim.jpg
// module id = mNCg
// module chunks = 0